module.exports = __webpack_public_path__ + "static/media/01_crisalide.8b7d46ab.jpg";